import request from '@/utils/request'
import config from '@/config'

export default {
  // 获取测站信息
  getRelation_info (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/relation_info', { params })
  },
  // 获取雨水情信息
  getRainWaterTotal (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetRainWaterTotal', { params })
  },
  // 危险区基本信息搜索
  getDangerAreaInfo (params) {
    return request.get(config.ApiYJ + '/Base/DangerAreaInfo', { params })
  },
  // 乡镇危险区表格list
  getDangerAreaInfotown (params) {
    return request.get(config.ApiYJ + '/Base/DangerAreaInfo/town', { params })
  },
  // 重要村落基本信息搜索
  getPreventionDataInfo (params) {
    return request.get(config.ApiYJ + '/Base/PreventionDataInfo', { params })
  },
  // 村落表格list
  getPreventionDataInfotown (params) {
    return request.get(config.ApiYJ + '/Base/PreventionDataInfo/town', { params })
  },
  // 村落预警信息
  getWarnVillageByTown (params) {
    return request.get(config.ApiYJ + '/WarnRecord/WarnVillageByTown', { params })
  },
  // 山塘信息
  getPreventionDataInfopool (params) {
    return request.get(config.ApiYJ + '/Base/PreventionDataInfo/pool', { params })
  }
}
